<template slot-scope="scope">
  <!-- 投诉申诉内容 -->
      <dialogModel
        title="投诉/申诉内容"
        :visible="dialogView"
        @handleClose="handleClose"
        :footer="false"
      >
        <div class="main-body">
          <div
            class="NoneData"
            v-if="listComplain.length == 0 && listAppeal.length == 0"
          >
            暂无 投诉/申诉 内容
          </div>
          <div class="content">
            <!-- 投诉内容 -->
            <div class="around-box interval">
              <div
                class="content-box"
                v-for="(item, index) in listComplain"
                :key="index"
              >
                <div class="content-content">
                  <div class="title-p">投诉内容：</div>
                  <div class="content-p">
                    {{ item.content }}
                  </div>
                </div>
                <div class="content-content">
                  <div class="title-p">投诉资料：</div>
                  <div class="content-p" v-if="item.attachmentName">
                    <i class="el-icon-document"></i>{{ item.attachmentName }}
                    <div class="icon firm-clickable" @click="handelDownload(item)">下载</div>
                  </div>
                </div>
                <div class="content-content">
                  <div class="title-p">投诉时间：</div>
                  <div class="content-p">{{ item.createTime }}</div>
                </div>
              </div>
            </div>
            <!-- 申诉内容 -->
            <div class="around-box">
              <div
                class="content-box"
                v-for="(item, index) in listAppeal"
                :key="index"
              >
                <div class="content-content">
                  <div class="title-p">申诉内容：</div>
                  <div class="content-p">
                    {{ item.content }}
                  </div>
                </div>
                <div class="content-content">
                  <div class="title-p">申诉资料：</div>
                  <div class="content-p" v-if="item.attachmentName">
                    <i class="el-icon-document"></i>{{ item.attachmentName }}
                    <div class="icon firm-clickable" @click="handelDownload(item)">下载</div>
                  </div>
                </div>
                <div class="content-content">
                  <div class="title-p">申诉时间：</div>
                  <div class="content-p">{{ item.createTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
// 引入接口
import {
  postGetStsDowLoadPath, // 生成临时下载链接
} from "../../../../../assets/api/index";
export default {
  props: {
    dialogView: {},
    contentList: {},
    result: {},
  },
  components: {},
  data() {
    return {
      textarea: "",
      listComplain: [], // 投诉内容列表
      listAppeal: [], // 申诉内容列表
    };
  },
  watch: {
    // 监听父组件传过来的数据
    contentList: {
      handler(newss, old) {
        var list1 = []; // 申诉
        var list2 = []; // 投诉
        var k = 0;
        var s = 0;
        // 循环筛选出 投诉内容/申诉内容放入两个数组方便后续展示
        for (var i in newss) {
          if (newss[i].type == 1) {
            list1[k++] = newss[i];
          } else {
            list2[s++] = newss[i];
          }
        }
        this.listComplain = list2;
        this.listAppeal = list1;
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    // 下载
    handelDownload(item) {
      postGetStsDowLoadPath(item.attachmentId).then((res) => {
        console.log(res);
        if (res.code == 0) {
          let a = document.createElement("a");
          a.href = res.data;
          a.click();
        }
      });
    },
    handleClose() {
      this.$emit("handleClose", this.result);
    },
    handleUnderstand() {
      this.$emit("handleUnderstand", this.result);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  min-height: 110px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  .around-box {
    width: 48%;
    min-height: 20px;
  }
  .interval {
    .content-box {
      width: 100%;
      margin-bottom: 40px;
      border-right: 1px solid #b7b7b7;
    }
  }
  .content-box {
    margin-bottom: 40px;
    .content-content {
      min-height: 20px;
      margin-bottom: 10px;
      display: flex;
      line-height: 20px;
      .title-p {
        width: 80px;
        flex-shrink: 0;
        white-space: nowrap;
        text-align: left;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
      .content-p {
        font-size: 12px;
        color: #666666;
        font-weight: 400;
        display: flex;
        flex-wrap: wrap;
        margin-right: 10px;
        word-break: break-all;
        i {
          font-size: 20px;
          margin-right: 5px;
        }
        .icon {
          width: 40px;
          height: 20px;
          background: #1a3270;
          border-radius: 2px;
          font-size: 10px;
          color: #ffffff;
          text-align: center;
          font-weight: 400;
          margin-left: 10px;
          cursor: pointer;
          line-height: 20px;
        }
      }
    }
  }
}
.NoneData {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>
